/// <amd-module name="TFS/Admin/Groups/Pivots/GroupMembers/Redux/GroupMembersPivotModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IGroupMembersPivotAwareState } from "TFS/Admin/Groups/Common/Contracts";
import { groupMembersReducer } from "TFS/Admin/Groups/Pivots/GroupMembers/Redux/GroupMembersPivotReducers";
import { groupMembersSaga } from "TFS/Admin/Groups/Pivots/GroupMembers/Redux/GroupMembersPivotSaga";

export function getGroupMembersPivotModule(): ISagaModule<IGroupMembersPivotAwareState> {
    const reducerMap: ReducersMapObject<IGroupMembersPivotAwareState, AnyAction> = {
        groupMembersState: groupMembersReducer
    };

    return {
        id: "membersPivotState",
        reducerMap,
        sagas: [groupMembersSaga]
    };
}
